import type { Step } from '@/types'

/** Shared ending steps — appears for ALL objectives */
export const endSteps: Step[] = [
  {
    id: 'thanks',
    type: 'message',
    content: 'Obrigado por participar, {{nome}}!',
  },
]
